import { useCallback, useEffect, useRef } from 'react'
import type { TelemetrySurface } from '@duck/api-definitions'
import { registerTelemetrySurface } from './workspaceTelemetry'

/**
 * Callback ref that registers its element as a telemetry surface whenever it mounts, so editors whose
 * root renders late (behind a loader or lazy Monaco) still register. Pass `null` to disable.
 */
export function useTelemetrySurfaceRef(surface: TelemetrySurface | null, getText: () => string): (el: HTMLElement | null) => void {
  const getTextRef = useRef(getText)
  getTextRef.current = getText
  const unregisterRef = useRef<(() => void) | null>(null)
  useEffect(() => () => { unregisterRef.current?.(); unregisterRef.current = null }, [])
  return useCallback((el: HTMLElement | null) => {
    unregisterRef.current?.()
    unregisterRef.current = null
    if (el !== null && surface !== null) unregisterRef.current = registerTelemetrySurface(surface, el, () => getTextRef.current())
  }, [surface])
}
